/**
 * @param housingValue Housing value
 * @param mortgageAmount Mortgage amount
 * @returns Loan-to-value ratio
 */
export function calculateLoanToValueRatio(housingValue, mortgageAmount) {
    if (housingValue <= 0) {
        return 0;
    }
    return mortgageAmount / housingValue;
}
